module.exports = __webpack_public_path__ + "static/img/BoycottBarImage.7247457.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/BoycottBarImage.png
// module id = 7ryw
// module chunks = 0